import React from 'react';
import searchIconImg from '../../../img/search-icon.svg';
import { I18n } from 'react-redux-i18n';
import './styles.scss';

const UniversalSearchField = ({
    value = "",
    handleFieldChange,
    handleSubmitOnEnterKey,
    handleSubmit,
}) => {
    return (
        <div className="universal-search-field pl-3 mr-3">
            <input
                type="text"
                value={value}
                onKeyDown={e => handleSubmitOnEnterKey(e)}
                onChange={e => handleFieldChange(e.target.value)}
                placeholder={I18n.t('search')}
            />
            <img style={{width: '1.2rem'}} src={searchIconImg} alt="" onClick={handleSubmit}/>
        </div>
    )
};

export default UniversalSearchField